export function initFileInput() {
    const numberFormatter = new Intl.NumberFormat('de', {
        maximumFractionDigits: 1,
    });

    const elements = document.querySelectorAll('.file-upload');
    for (const element of elements) {
        const input = element.querySelector('input[type="file"]');

        const maxFiles = input.multiple
            ? parseInt(input.dataset.maxFiles ?? '5')
            : 1;

        const maxFileSize = parseInt(element.dataset.maxFileSize ?? Number.MAX_SAFE_INTEGER);

        /** @type {{removeFile: string, fileTooLarge: string}} */
        const messages = {
            removeFile: window.c3.translations.input.file.removeFile,
            fileTooLarge: window.c3.translations.input.file.error.fileTooLarge,
        };

        const items = element.querySelector('.file-upload-list');

        const transfer = new DataTransfer();

        input.addEventListener('change', () => {
            _updateInput([...input.files]);
        });

        /** @type {Set<File | {}>} */
        const allFiles = new Set();

        const existingFiles = JSON.parse(input.dataset.existingFiles ?? '[]');
        for (const file of existingFiles) {
            allFiles.add(file);
        }

        _renderFiles();

        /**
         * @param {File[]} addedFiles
         * @private
         */
        function _updateInput(addedFiles = []) {
            const remainingFiles = Math.max(maxFiles - transfer.files.length, 0);

            /** @type {File[]} */
            const files = addedFiles.slice(0, remainingFiles);
            for (const file of files) {
                if (file.size > maxFileSize) {
                    alert(messages.fileTooLarge.replace('%s', file.name));
                    continue;
                }

                transfer.items.add(file);
            }

            input.files = transfer.files;
            for (const file of input.files) {
                allFiles.add(file);
            }

            const full = allFiles.size >= maxFiles;
            element.classList.toggle('file-upload--full', full);

            items.innerHTML = '';

            _renderFiles();
        }

        function _renderFiles() {
            for (const file of allFiles) {
                if (file instanceof File) {
                    items.append(_createItem(file.name, file.type, file.size, URL.createObjectURL(file), () => {
                        const fileIdx = [...input.files].findIndex(f => f === file);
                        transfer.items.remove(fileIdx);
                        allFiles.delete(file);
                        _updateInput();
                    }));
                } else {
                    const item = _createItem(file.fileName, file.fileType, file.fileSize, file.preview, () => {
                        allFiles.delete(file.hash);
                    });

                    const hiddenInput = document.createElement('input');
                    hiddenInput.type = 'hidden';
                    hiddenInput.name = file.name;
                    hiddenInput.value = file.hash;

                    item.append(hiddenInput);
                    items.append(item);
                }
            }
        }

        /**
         *
         * @param {string} fileName
         * @param {string} fileType
         * @param {number} fileSize
         * @param {string} src
         * @param {() => void} onRemove
         * @returns {HTMLDivElement}
         * @private
         */
        function _createItem(fileName, fileType, fileSize, src, onRemove) {
            const splitName = fileName.split('.');
            const extension = splitName[splitName.length - 1];
            const cleanName = splitName.slice(0, splitName.length - 1).join('.');

            let previewElement;
            if (fileType.startsWith('image/')) {
                previewElement = document.createElement('img');
                previewElement.src = src;
                previewElement.width = 32;
                previewElement.height = 32;
                previewElement.ariaHidden = 'true';
            } else if (fileType.startsWith('video/')) {
                previewElement = document.createElement('video');
                previewElement.src = src;
                previewElement.width = 32;
                previewElement.height = 32;
                previewElement.muted = true;
                previewElement.controls = false;
                previewElement.playsInline = true;
                previewElement.ariaHidden = 'true';
            } else {
                previewElement = document.createElement('span');
                previewElement.innerText = extension.toUpperCase();
            }

            const item = document.createElement('div');
            item.classList.add('file-upload-item');
            item.ariaLabel = fileName;

            const previewFrame = document.createElement('div');
            previewFrame.classList.add('file-upload-item-preview');
            previewFrame.append(previewElement);
            item.append(previewFrame);

            const fileInfo = document.createElement('div');
            fileInfo.classList.add('file-upload-item-info');
            const fileInfoName = document.createElement('p');
            fileInfoName.classList.add('file-upload-item-info-name');
            fileInfoName.innerText = cleanName;
            fileInfo.append(fileInfoName);
            const fileInfoMeta = document.createElement('p');

            let cleanFileSize;
            if (fileSize > 100000) {
                cleanFileSize = `${numberFormatter.format(fileSize / (1024 * 1024))} MB`;
            } else {
                cleanFileSize = `${numberFormatter.format(fileSize / 1024)} KB`;
            }

            fileInfoMeta.innerText = `${extension.toUpperCase()} · ${cleanFileSize}`;
            fileInfo.append(fileInfoMeta);
            item.append(fileInfo);

            const removeBtn = document.createElement('button');
            removeBtn.classList.add('file-upload-item-remove');
            removeBtn.title = messages.removeFile;
            removeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#9DC384" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
            removeBtn.addEventListener('click', () => {
                item.remove();
                onRemove();
            });
            item.append(removeBtn);
            return item;
        }
    }
}
